import m from "../../../../geodata/es2015/region/usa/deHigh";
window.am4geodata_region_usa_deHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/deHigh.js
// module id = null
// module chunks = 